import noop from 'lodash/noop';
import React from 'react';
import { getReferrerType } from '../../utils/getReferrerType';
import { lazyImport, LazyComponent } from '../LazyImportComponent';
import { REFERRER_TYPE_WIDGET } from './constants';
import TimesGridTooltipWrapper from './TimesGridTooltipWrapper';

const getTimesgrid = lazyImport(
    () =>
        import(
            /* webpackChunkName: "timesgrid", webpackPrefetch: 20 */ './Timesgrid'
        ),
    'Timesgrid'
);

const columnBreakpoints = {
    4: 768,
};

/**
 * @param {string} directoryId
 * @param {string} insuranceCarrierId
 * @param {string} insurancePlanId
 * @param {boolean} isMobile
 * @param {boolean} isNewPatient
 * @param {boolean} isReschedule
 * @param {string} locationCloudId
 * @param {function(timeslot: Object, e: Object): void}onTimeSlotClicked
 * @param {string} procedureId
 * @param {string} providerCloudId
 * @param {boolean} hasAppointmentTimeError
 * @returns {JSX.Element}
 * @constructor
 */
const TimesGridWithTooltip = ({
    directoryId,
    insuranceCarrierId,
    insurancePlanId,
    isMobile,
    isNewPatient,
    isReschedule,
    locationCloudId,
    onTimeSlotClicked,
    procedureId,
    providerCloudId,
    hasAppointmentTimeError,
}) => {
    const referrerType = getReferrerType();
    const isWidget =
        typeof referrerType === 'string'
            ? referrerType.toLowerCase() === REFERRER_TYPE_WIDGET
            : false;

    const Timesgrid = getTimesgrid();

    const timesgrid = (
        <LazyComponent componentName="Timesgrid" onFailure={noop}>
            <Timesgrid
                columnBreakpoints={columnBreakpoints}
                data-test="timesgrid-with-tooltip"
                directoryId={directoryId}
                initialRowCount={5}
                insuranceCarrierId={insuranceCarrierId}
                insurancePlanId={insurancePlanId}
                isExistingPatient={!isNewPatient}
                isNewPatient={isNewPatient}
                isReschedule={isReschedule}
                locationId={locationCloudId}
                onClickTimeslot={onTimeSlotClicked}
                onTimeSlotClicked={onTimeSlotClicked}
                procedureId={procedureId}
                providerId={providerCloudId}
                jumpAhead={isMobile}
                widget={isWidget}
            />
        </LazyComponent>
    );

    if (hasAppointmentTimeError) {
        return (
            <TimesGridTooltipWrapper
                isMobile={isMobile}
                timesgrid={timesgrid}
            />
        );
    } else {
        return timesgrid;
    }
};

export default TimesGridWithTooltip;
